module.exports = __webpack_public_path__ + "img/BOHN.328881a9.png";